module.exports = __webpack_public_path__ + "static/media/20200506-2.dcd058ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20200506/img/20200506-2.png
// module id = 317
// module chunks = 0